import {curry, isFunction} from './function'

export const inRange = curry((min, max, val) => val >= min && val < max)

export const isFinite = (val) => {
  if (isFunction(Number.isFinite)) return Number.isFinite(val)
  return typeof val === 'number' ? !isNaN(val) && val !== -Infinity && val !== Infinity: false
}



// WEBPACK FOOTER //
// ./src/utils/number.js